import React from 'react';
import { RefinementList } from 'react-instantsearch-dom';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';

import FilterBlock from '../../elements/FilterBlock';
import HierarchicalMenuMulti from '../../elements/HierarchicalMenuMulti';

const MemberFilters = () => (
    <>
        <FilterBlock label="Business Type" attribute="business_type">
            <div className="mb-3">
                <HierarchicalMenuMulti
                    attribute="business_type"
                    limit={99999}
                    transformItems={items => sortBy(items, ['label'])}
                />
            </div>
        </FilterBlock>

        <FilterBlock label="Country" attribute="location.country">
            <RefinementList
                attribute="location.country"
                limit={99999}
                transformItems={items => {
                    const sorted = sortBy(items, ['label']);
                    const usIndex = sorted.findIndex(item => item.label === 'United States');

                    if (usIndex >= 0) {
                        const usItem = sorted[usIndex];
                        sorted.splice(usIndex, 1);
                        sorted.unshift(usItem);
                    }

                    return sorted;
                }}
            />
        </FilterBlock>

        <FilterBlock label="State/Province" attribute="location.state">
            <RefinementList
                attribute="location.state"
                limit={99999}
                transformItems={items => sortBy(items, ['label'])}
            />
        </FilterBlock>

        <FilterBlock label="Global Region" attribute="location.region">
            <RefinementList attribute="location.region" limit={99999} />
        </FilterBlock>

        <FilterBlock label="Business Responsibility" attribute="Business Responsibility">
            <RefinementList attribute="responsibility" limit={99999} />
        </FilterBlock>

        <FilterBlock label="Title Category" attribute="functional_title">
            <RefinementList attribute="functional_title" limit={99999} />
        </FilterBlock>

        <FilterBlock label="Designation" attribute="designations.value">
            <RefinementList attribute="designations.value" limit={99999} />
        </FilterBlock>
    </>
);

MemberFilters.propTypes = {};

export default MemberFilters;
